<template>
  <div class="share">
    <a
      class="share-btn share-btn-tw"
      rel="noopener"
      target="_blank"
      :href="links.twitter"
      :title="$t('success.share.twitter')"
      v-t="'success.share.twitter'"
      @click="handleTwitterClick"
    />
    <a
      class="share-btn share-btn-in"
      rel="noopener"
      target="_blank"
      :href="links.linkedin"
      :title="$t('success.share.linkedin')"
      v-t="'success.share.linkedin'"
      @click="handleLinkedinClick"
    />
    <a
      class="share-btn share-btn-fb"
      rel="noopener"
      target="_blank"
      :href="links.facebook"
      :title="$t('success.share.facebook')"
      v-t="'success.share.facebook'"
      @click="handleFacebookClick"
    />
  </div>
</template>

<script>
import store from '@/store';
import { getPublishedSiteUrl } from '@/utils/getSiteUrls';

export default {
  computed: {
    links() {
      const encodedUrl = encodeURIComponent(getPublishedSiteUrl(store));
      const title = encodeURIComponent(this.$t('success.share.message.title'));
      const summary = encodeURIComponent(this.$t('success.share.message.summary'));

      return {
        twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${summary}`,
        linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${title}&summary=${summary}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&t=${summary}`,
      };
    },
  },
  methods: {
    handleTwitterClick() {
      this.sendGAEvent('twitter');
    },
    handleLinkedinClick() {
      this.sendGAEvent('linkedin');
    },
    handleFacebookClick() {
      this.sendGAEvent('facebook');
    },
    sendGAEvent(event_label) {
      if (window.gtag) {
        window.gtag('event', 'click', { event_category: 'Share', event_label });
      }
    },
  },
};
</script>

<style scoped src="./successPaymentShare.css"></style>
